/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M4.08 9.917A7.926 7.926 0 0 1 11.997 2a7.926 7.926 0 0 1 7.917 7.916c0 5.455-5.452 10.408-7.119 11.796a1.25 1.25 0 0 1-1.597 0c-1.67-1.388-7.118-6.34-7.118-11.795Zm3.75 0a4.167 4.167 0 1 0 8.334 0 4.167 4.167 0 0 0-8.334 0Z"
})), "0 0 24 24", "Location");